<template>
    <div>
        <div id="mainsCharts" style="width:600px;background-color:#e0e0e0"></div>
    </div>
</template>

<script>
import * as echarts from 'echarts'
export default {
    data() {
        return{
            mathsize: [
                { name: '环翠区',math: 331, itemId:1 },
                { name: '高新区',math: 330, itemId:2 },
                { name: '南海新区',math: 290, itemId:3 },
                { name: '芝罘区',math: 280, itemId:4 },
                { name: '福山区',math: 270, itemId:5 },
                { name: '开发区',math: 260, itemId:6 },
                { name: '开发区',math: 260, itemId:6 },
                { name: '开发区',math: 260, itemId:6 },
                { name: '开发区',math: 260, itemId:6 },
                { name: '开发区',math: 260, itemId:6 },
                { name: '开发区',math: 260, itemId:6 },
                { name: '开发区',math: 260, itemId:6 },
                { name: '开发区',math: 260, itemId:6 },
                { name: '开发区',math: 260, itemId:6 },
                { name: '开发区',math: 260, itemId:6 },
                { name: '开发区',math: 260, itemId:6 },
                { name: '莱山区',math: 250, itemId:7 },
                { name: '牟平区',math: 240, itemId:8 },
                { name: '牟平区',math: 240, itemId:8 },
                { name: '牟平区',math: 240, itemId:8 },
                { name: '牟平区',math: 240, itemId:8 },
                { name: '牟平区',math: 240, itemId:8 },
                { name: '牟平区',math: 240, itemId:8 },
                { name: '牟平区',math: 240, itemId:8 },
                { name: '牟平区',math: 240, itemId:8 },
                { name: '牟平区',math: 240, itemId:8 },
                { name: '牟平区',math: 240, itemId:8 },
                { name: '牟平区',math: 240, itemId:8 },
                { name: '牟平区',math: 240, itemId:8 },
                { name: '牟平区',math: 240, itemId:8 },
                { name: '牟平区',math: 240, itemId:8 },
                { name: '牟平区',math: 240, itemId:8 },
                { name: '牟平区',math: 240, itemId:8 },
                { name: '牟平区',math: 240, itemId:8 },
                { name: '牟平区',math: 240, itemId:8 },
                { name: '牟平区',math: 240, itemId:8 },
                { name: '牟平区',math: 240, itemId:8 },


            ],
        }    
    },
    mounted(){
        this.HistogramChage()
    },
    methods:{
        HistogramChage(){
            var myChart12 = echarts.init(document.getElementById('mainsCharts'))
            let height = this.mathsize.length*30+200
            myChart12.resize({height:height}); 
            var includemath=[]
            this.mathsize.forEach((item) => {
                includemath.push({
                name: item.name,//这个变量是控制他不同颜色的 不同的值就是不同的颜色
                type: 'bar',
                barMaxWidth: '40px',
                barMinWidth: '25px',
                // data:[{'value':item.math}],
                data: [{ 'value': item.math, 'date': item.itemId }],//这步是为了下面点击的时候显示内容 date的变量可以更改  更改后在底下点击显示改过来就行
                itemStyle: {
                    normal: {
                    label: {
                        show: true,
                        // formatter: item.projectTitle+' '+item.time,//联调的时候会用到  这里接收两个值   一个前面的值  一个后面的日期时间
                        position:'insideRight',//inside是内部  insideRight是内部靠右边
                        textStyle: {
                        color: '#fff',
                        fontSize: 16,
                        align: 'right'
                        }
                    }
                    }
                }
                })
            })
            var optionCharts
            optionCharts = {
                color: ['rgba(245, 59, 35, 0.897)', 'gray', 'skyblue', 'orange', 'green', 'rgba(195, 233, 27, 0.733)', 'purple', 'pink','black'],
                legend: {
                    top: 0,
                    // bottom:30,
                    left: '10%',
                    // data:this.fillListZ,
                    textStyle: { color: '#000' }
                },
                grid: {
                    left:0,
                    bottom:0,
                    top:0,
                    right:0,
                    // containLabel: true
                },
                xAxis: {
                    boundaryGap : [0, 0],
                    position: 'top',
                    axisLabel: {
                    color: '#fff'
                    },
                    axisLine: {
                    lineStyle: {
                        color: '#fff'
                    },
                    show: false // 不显示坐标轴线
                    },
                    axisTick: {
                    show: false// 不显示坐标轴刻度线
                    },
                    type: 'value',
                    // eslint-disable-next-line no-dupe-keys
                    axisLabel: {
                    show: false // 不显示坐标轴上的文字
                    },
                    splitLine: {
                    show: false// 不显示网格线
                    }
                },
                yAxis: {
                    inverse:true,//是否反向坐标
                    type: 'category',
                    position:'top',
                    axisLabel: {
                    textStyle: {
                        color: '#fff'
                    },
                    show: true
                    },
                    axisLine: {
                    lineStyle: {
                        color: '#fff'
                    },
                    show: false // 不显示坐标轴
                    }
                },
                // dataZoom:[{
                //         type: 'slider',
                //         show: true,
                //         "filterMode": "empty",
                //         "disabled": false,
                //         yAxisIndex: 0,
                //         // AxisIndex:0,
                //         // top: '25%',
                //         right: '5%',
                //         // bottom: '15%',
                //         width: 10,
                //         start: 50,
                //         end: 0,
                //         handleSize: '0', // 滑动条的 左右2个滑动小块的大小
                //         // handleIcon: 'path://M306.1,413c0,2.2-1.8,4-4,4h-59.8c-2.2,0-4-1.8-4-4V200.8c0-2.2,1.8-4,4-4h59.8c2.2,0,4,1.8,4,4V413z',
                //         textStyle: {
                //             color: "#fff"
                //         },
                //         fillerColor: '#3C62C0', // 拖动条的颜色
                //         borderColor: "none",
                //         backgroundColor: 'rgba(60, 98, 192, 0.302)',
                //         showDetail: false // 即拖拽时候是否显示详细数值信息 默认true
                // }],
                series: includemath
            }
            myChart12.setOption(optionCharts,true)
        }
    }
}
</script>

<style scoped>

</style>